import styled from 'styled-components';
import React from 'react';
import { Link } from 'react-router-dom'
import { mobile } from '../responsive';

const Container = styled.div`
    flex: 1;
    margin: 3px;
    min-width: 30%;
    height: 70vh;
    position: relative;
`;
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    ${mobile({ height: "20vh" })}
`;
const Info = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const Title = styled.h1`
    color: black;
    margin-bottom: 2px;
    background-color: white;
    border: 3px solid;
    border-color: #0039a6;
`;
const Button = styled.button`
    border: 3px solid;
    padding: 10px;
    background-color: white;
    cursor: pointer;
    font-weight: 600;
    border-color: #0039a6;
`;

const CategoryItem = ({ item }) => {
  return (
    <Container>
        <Image src={item.img}/>
        <Info>
            <Title>{item.title}</Title>
            <Button><Link to={item.link} style={{color: 'black'}}>View Now</Link></Button>
        </Info>
    </Container>
  )
}

export default CategoryItem